import React from 'react';

export function InputText(props) {
  
  return ( 
    <>
      <input 
        type={props.type}
        autoComplete="off" 
        value={props.value || ''} 
        step='any'
        onChange={props.onChange} 
        placeholder={props.placeholder}
        className = {`form__input font20Norm form__input_type_${props.name} ${props.error ? 'form__error' : ''}`} 
        name={props.name} 
        id={props.id} 
      /> 
      {props.error && <span className="form__text_error font14Norm">{props.error}</span>}
    </>
  )        
}
  